import { IItemNameType, SortedMappingItem } from '@modeso/types__aumico-lib-annualreport-be';

export type INameIdWithSortedItems = {
    id: string;
    name: string;
    sortedItems: SortedMappingItem[] | IItemNameType[];
    isDirectParent?: boolean;
};
